var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { ref: "tableheader", staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.searchForm,
                    "label-width": "80px",
                    "label-position": _vm.labelPosition,
                  },
                },
                [
                  !_vm.collapse
                    ? _c(
                        "div",
                        { staticClass: "acea-row search-form" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-form-box" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "集市名称：",
                                    "label-for": "marketName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      placeholder: "请输入集市名称",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.marketName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "marketName",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.marketName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "经营环境：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "请选择经营环境",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.searchForm.environmentType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "environmentType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchForm.environmentType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "室内", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "室外", value: 1 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "集市类型：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "请选择集市类型",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.searchForm.marketType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "marketType",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.marketType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "长期", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "短期", value: 1 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "集市属性：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "请选择集市属性",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.searchForm.siteType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "siteType",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.siteType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "商圈", value: 1 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "社区", value: 2 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "公园", value: 3 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "场馆", value: 4 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "景区", value: 5 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "乐园", value: 6 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "展会", value: 7 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "状态：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "请选择状态",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.searchForm.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.status",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "上架中", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "已下架", value: 1 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "search-form-sub" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleSearchList },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleReset("searchForm")
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c("div", { staticClass: "acea-row row-between-wrapper mb15" }, [
            _c("div", { staticClass: "header-title" }, [_vm._v("集市列表")]),
            _c(
              "div",
              { staticClass: "header-btn" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["merchant:market:save"],
                        expression: "['merchant:market:save']",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v(" 新增集市 ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                height: _vm.tableHeight,
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "70", align: "right" },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.status === 0 ? "success" : "danger",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.status === 0 ? "上架中" : "已下架"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "集市图片", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview line-heightOne" },
                          [
                            _vm.getFirstImage(scope.row.marketImg)
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                    "border-radius": "4px",
                                  },
                                  attrs: {
                                    src: _vm.getFirstImage(scope.row.marketImg),
                                    "preview-src-list": _vm.getImageList(
                                      scope.row.marketImg
                                    ),
                                    fit: "cover",
                                  },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                      "border-radius": "4px",
                                      background: "#f5f7fa",
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "center",
                                      color: "#909399",
                                      "font-size": "12px",
                                    },
                                  },
                                  [_vm._v(" 无图片 ")]
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "集市名称",
                  "min-width": "150",
                  prop: "marketName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              trigger: "hover",
                              placement: "right",
                              "open-delay": 800,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text_overflow",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.marketName))]
                            ),
                            _c("div", { staticClass: "pup_card" }, [
                              _vm._v(_vm._s(scope.row.marketName)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "集市类型", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.marketType === 0
                                  ? "success"
                                  : "warning",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.marketType === 0 ? "长期" : "短期"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "经营环境", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.environmentType === 1
                                  ? "primary"
                                  : "info",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.environmentType === 0
                                    ? "室内"
                                    : "室外"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "集市属性", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tag", { attrs: { size: "mini" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.getSiteTypeName(scope.row.siteType)) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "详细地址", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.detail) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "容纳摊位数",
                  width: "100",
                  align: "center",
                  prop: "capacity",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "联系人", width: "100", prop: "contactPerson" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系电话",
                  width: "120",
                  prop: "contactPhone",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "备注", width: "120", prop: "remark" },
              }),
              _c("el-table-column", {
                attrs: { label: "创建时间", width: "150", prop: "createTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "170", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            scope.row.status === 0
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "merchant:market_activity:save",
                                        ],
                                        expression:
                                          "['merchant:market_activity:save']",
                                      },
                                    ],
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCreateActivity(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 创建活动 ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["merchant:market:update"],
                                    expression: "['merchant:market:update']",
                                  },
                                ],
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 详情 ")]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["merchant:market:update"],
                                    expression: "['merchant:market:update']",
                                  },
                                ],
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 编辑 ")]
                            ),
                            scope.row.status === 1
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["merchant:market:publish"],
                                        expression:
                                          "['merchant:market:publish']",
                                      },
                                    ],
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePublish(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 上架 ")]
                                )
                              : _vm._e(),
                            scope.row.status === 0
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["merchant:market:pullDown"],
                                        expression:
                                          "['merchant:market:pullDown']",
                                      },
                                    ],
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePullDown(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 下架 ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["merchant:market:delete"],
                                    expression: "['merchant:market:delete']",
                                  },
                                ],
                                staticStyle: { color: "#f56c6c" },
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 删除 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "acea-row row-center-wrapper mt15" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.tableFrom.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.tableFrom.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "market-detail-drawer",
          attrs: {
            title: "集市详情",
            visible: _vm.detailDrawerVisible,
            direction: "rtl",
            size: "60%",
            "before-close": _vm.handleDetailClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDrawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticClass: "drawer-content",
            },
            [
              _vm.currentMarketDetail
                ? _c("MarketDetail", {
                    attrs: { marketData: _vm.currentMarketDetail },
                  })
                : _c("div", { staticClass: "no-data" }, [
                    _c("i", { staticClass: "el-icon-warning" }),
                    _c("span", [_vm._v("暂无详情数据")]),
                  ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }